import { useState, useMemo, useCallback } from "react";

import { WIZARD_STEPS, steps, type StepType, type IStepConfig } from "./types";

interface IUseWizardNavigationReturn {
    currentStep: StepType;
    setCurrentStep: (step: StepType) => void;
    goToNextStep: () => void;
    goToPrevStep: () => void;
    currentStepIndex: number;
    totalSteps: number;
    getCurrentStepConfig: () => IStepConfig;
    resetNavigation: () => void;
}

export const useWizardNavigation = (): IUseWizardNavigationReturn => {
    const [currentStep, setCurrentStep] = useState<StepType>(steps.COUNTRIES);

    const currentStepIndex = useMemo(() => {
        return WIZARD_STEPS.findIndex((step) => step.name === currentStep);
    }, [currentStep]);

    const totalSteps = WIZARD_STEPS.length;

    const getCurrentStepConfig = useCallback(() => {
        return WIZARD_STEPS[currentStepIndex];
    }, [currentStepIndex]);

    const goToNextStep = useCallback(() => {
        if (currentStepIndex < WIZARD_STEPS.length - 1) {
            const nextStep = WIZARD_STEPS[currentStepIndex + 1];
            setCurrentStep(nextStep.name as StepType);
        }
    }, [currentStepIndex]);

    const goToPrevStep = useCallback(() => {
        if (currentStepIndex > 0) {
            const prevStep = WIZARD_STEPS[currentStepIndex - 1];
            setCurrentStep(prevStep.name as StepType);
        }
    }, [currentStepIndex]);

    const resetNavigation = useCallback(() => {
        setCurrentStep(steps.COUNTRIES);
    }, []);

    return {
        currentStep,
        setCurrentStep,
        goToNextStep,
        goToPrevStep,
        currentStepIndex,
        totalSteps,
        getCurrentStepConfig,
        resetNavigation,
    };
};
